const env = {
	serverUrl: 'https://rangers-db.herokuapp.com',
	decksPerPage: 9,
};

export default env;
